// utils/auth.js

import { useNavigate } from 'react-router-dom';

const { navigate } = useNavigate;

export const getToken = () => {
  try {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
            console.warn('No token found in localStorage.');
        }
        return token;
    } catch (error) {
        console.error('Error retrieving token:', error);
        return null; // or handle the error as needed
    }
};

export const getUser = () => {     
    try {
        const user = JSON.parse(localStorage.getItem('user'));              
        if (!user) {
            console.warn('No user found in localStorage.');
            navigate('/login');
        }
        return user;
    } catch (error) {
        console.error('Error retrieving user:', error);
        return null; // or handle the error as needed
    }
}

export const getUserName = ()  => {
    try {
        const UserName = localStorage.getItem('userId');
        if (!UserName) {
            console.warn('No UserName found in localStorage.');
        }
        return UserName;
    } catch (error) {
        console.error('Error retrieving UserName:', error);
        return null; // or handle the error as needed
    } 
}